/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-05-16 20:54:38
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-17 19:45:34
 * @FilePath: \baishu_react_ui\src\components\dashboard\BsyDashboardCustomApp\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from "react";
import "./index.css";
import BsyTab from "../../BsyTab";
import BsyAlertMenu from "../../BsyAlertMenu";
import tipAlert from "../../../Login/BsyAlertTip/Staticize";
import BsyAlert from "../../BsyAlert";
import { BsyUtils } from "../../../utils/Utils";
import BsyAlertTextEdit from "../../BsyAlertTextEdit";
import BsyAlertQrcode from "../../BsyAlertQrcode";
import BsyMaskLayer from "../../BsyMaskLayer";
import BsySLoading from "../../BsySLoading";
import { EditStandardApp } from "../../BsyAppPane/EditStandardApp";
import BsyDialog from "../../BsyDialog";
import { UnbindApp } from "../../BsyAppPane/unBindApp";
import BsySlidePane from "../../BsySlidePane";
import UpdateStandardAppPane from "../../BsyAppPane/UpdateStandardAppPane";
import { CreateApp, GroupSelectPane } from "./CreateApp";
import { createTooltip } from "../../../utils/createTooltip";
import pubsub from "pubsub-js";
import { dayjsUtils } from "../../../utils/dayjsUtils";

class BsyDashboardMyApp extends Component {
  static defaultProps = {
    customApp: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      customApp: props.customApp,
      apps: props.apps || [],
      items: [],
      active: "all",
      appNewList: BsyUtils.Store.get("appNewList") || [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const customApp = { ...nextProps.customApp };
    const tabitem = this.getAppGroupList(nextProps.apps || []);
    const active =
      this.props.mode === "edit"
        ? tabitem?.[0]?.key
        : this.state.active || tabitem?.[0]?.key;

    this.setState({
      customApp: customApp,
      apps: nextProps.apps || [],
      items: tabitem,
      active: tabitem.find((item) => item.key === active)?.key || "all",
    });
  }

  componentWillUnmount() {
    this.hideTooltip();
  }

  async componentDidMount() {
    const { show, hide } = createTooltip();
    this.showTooltip = show;
    this.hideTooltip = hide;
    const tabitem = this.getAppGroupList(this.props.apps || []);

    let hasUpdate = false;
    (this.props.apps || []).map((res) => {
      res.apps.map((res1) => {
        if (res1.appType === 4) {
          hasUpdate = true;
        }
        return null;
      });
      return null;
    });

    let standardUpdateCont = {};
    if (
      hasUpdate &&
      (window.FX.STATIC.user_corps.isSysManager ||
        window.FX.STATIC.user_corps.isCorpOwn)
    ) {
      let res = await React.axios("/dashboard/standard_check_renew");
      standardUpdateCont = res.data;
    }

    this.setState(
      {
        active: this.props.mode === "edit" ? tabitem?.[0]?.key : "all",
        items: tabitem,
        appNewList: BsyUtils.Store.get("appNewList") || [],
        standardUpdateCont: standardUpdateCont,
      },
      () => {
        this.props?.onRefreshChars?.({ type: "myApp" });
        this.props?.onStandardAppUpdate(standardUpdateCont.hasRenew);
      }
    );
  }

  showUpdateTip = (data) => {
    const { standardUpdateCont } = this.state;
    console.log(standardUpdateCont, data);

    let updateCont = standardUpdateCont.list.find((item) =>
      item.appIds.includes(data._id)
    );

    if (!updateCont) {
      return;
    }

    BsyDialog({
      title: React.language("app") + React.language("update"),
      height: 260,
      width: 440,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        return (
          <div style={{ marginTop: "10px" }}>
            <div className="update-doc">
              <div className="update-doc-title">
                {React.language("Update.cont")}
              </div>
              <div className="update-doc-content">{updateCont.remark}</div>
            </div>
            <div className="update-url">
              <div className="update-doc-title">
                {React.language("Doc.link")}
              </div>

              <a
                href={updateCont.docUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {updateCont.docUrl}
              </a>
            </div>
          </div>
        );
      },
    });
  };

  groupItem = (data, groupId) => {
    // console.log("groupItem", this.state)
    const { appNewList = [], standardUpdateCont = {} } = this.state || {};
    const hasAuth =
      window.FX.STATIC.user_corps.isSysManager ||
      data.editable ||
      data.deletable ||
      data.copyable;
    const id = `${groupId}-${data._id}`;
    // console.log(id);

    const newApp = appNewList.indexOf(data._id) > -1;
    const hasUpdate =
      standardUpdateCont &&
      standardUpdateCont.appIds &&
      standardUpdateCont.appIds.indexOf(data._id) > -1;

    return (
      <div
        className={`bys-group-box-item ${data.appType === 3 || data.appType === 4 ? "standard" : ""
          } ${newApp ? "new" : ""} ${hasUpdate ? "update" : ""}`}
        style={{ marginBottom: `16px` }}
        id={data._id}
        onClick={this.selectApp(data)}
        key={id}
        data-id={id}
      >
        {data.appType === 4 && !newApp && hasUpdate && (
          <div
            className="updateTip"
            onClick={(e) => {
              e.stopPropagation();
              this.openUpdateStandardAppPane(data._id);
            }}
          onMouseEnter={(e) => {
            this.showTooltip(
              e.currentTarget,
              React.language("update"),
              "bottom",
              10
            );
          }}
          onMouseLeave={() => {
            this.hideTooltip();
          }}
          >
            <i className="icon-bsy-import-export"></i>
          </div>
        )}
        {data.appType === 4 && newApp && (
          <div className="newTip">
            <span>{React.language("new.export.app")}</span>
          </div>
        )}
        <div className="view">
          <div className="app-wrapper">
            <div className="icon-wrapper">
              <div className={"icon-backgroup color-cover-" + data.style.color}>
                <div
                  className={"imgbg-bsy-app imgbg-bsy-app-" + data.style.icon}
                ></div>
              </div>
            </div>
            <div
              className="app-title"
              title={data.appname}
              id={"app_title_" + data._id}
            >
              {data.appname}
            </div>
          </div>
        </div>
        {hasAuth && !data.dock && (
          <i
            className="icon-bsy-iconshezhi app-info"
            onClick={(event) => {
              this.moreMenu(data, event);
            }}
          />
        )}

        {data.isFavorite ? (
          <i
            onMouseEnter={(e) => {
              this.showTooltip(
                e.currentTarget,
                data.isFavorite
                  ? React.language("app.favorites.cancel")
                  : React.language("app.favorites.tip"),
                "bottom",
                10
              );
            }}
            onMouseLeave={() => {
              this.hideTooltip();
            }}
            className={`icon-bsy-favorite ${data.isFavorite ? "select" : ""}`}
            onClick={(event) => {
              event.stopPropagation();
              this.favorite(data, data.isFavorite);
            }}
          />
        ) : (
          <i
            onMouseEnter={(e) => {
              this.showTooltip(
                e.currentTarget,
                data.isFavorite
                  ? React.language("app.favorites.cancel")
                  : React.language("app.favorites.tip"),
                "bottom",
                10
              );
            }}
            onMouseLeave={() => {
              this.hideTooltip();
            }}
            className={`icon-new-shoucangxianxing`}
            onClick={(event) => {
              event.stopPropagation();
              this.favorite(data, data.isFavorite);
            }}
          />
        )}
      </div>
    );
  };

  favorite = (data, status) => {
    // 直接更新状态，不等后端返回
    this.props?.onUpdataApps(
      this.state.apps.map((item) => {
        return {
          ...item,
          apps: item.apps.map((res) => {
            if (res._id === data._id) {
              return {
                ...res,
                isFavorite: !status,
              };
            }
            return res;
          }),
        };
      })
    );
    this.hideTooltip();
    React.axios(
      !status ? "/dashboard/favorite_add" : "/dashboard/favorite_remove",
      {
        favorites: [
          {
            type: "app",
            appId: data._id,
          },
        ],
      }
    ).then((res) => {
      const { data: resData } = res;
      if (resData.code === 200) {
        this.props?.onUpdataApps(null, true);
      } else if (resData.code === 400) {
        tipAlert({
          type: "error",
          msg: resData.msg || React.language("error.201"),
        });
      }
    });
  };

  _appReName = (a, cl, d, cb) => {
    let _this = this;

    BsyAlertTextEdit({
      title: React.language("msg.type.app_rename"),
      placeholder: React.language("enter.new.appName"),
      value: d,
      width: 350,
      onOk: (name) => {
        let result = {};
        if (
          !BsyUtils.checkValidateTitle(name, React.language("app.name"), result)
        ) {
          return;
        }

        React.axios("/dashboard/app/" + a + "/update", {
          name: name,
        })
          .then(function (res) {
            if (!BsyUtils.isObjectEmpty(res.data.app)) {
              const newApps = _this.state.apps.map((item) => {
                item.apps.map((res1) => {
                  if (res1._id === a) {
                    res1.appname = res.data.app.name;
                  }
                  return res1;
                });
                return item;
              });
              _this.setState({
                apps: newApps,
                items: _this.getAppGroupList(newApps || []),
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      onCancel: () => { },
    });
  };

  _appEditStyle = (renderEl, data) => {
    let FX = window.FX;
    let $ = window.$;
    let _this = this;
    let colors = [3, 5, 1, 2, 0, 4];
    let icons = [
      25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42,
      43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
      61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
    ];

    let curre_val = {
      color: parseInt(data.style.color),
      icon: parseInt(data.style.icon),
    };
    function setIconChoose(a1, b1) {
      if (data.style.icon <= 24) {
        return parseInt(data.style.icon) === a1 ? "selected" : ""
      } else {
        return parseInt(data.style.icon) === b1 ? "selected" : ""
      }
    }
    let color = $('<ul class="menu-pane-color"/>');
    BsyUtils.forEach(colors, function (a1, b1) {
      color.append(
        $('<span class="menu-item color-cover-' + b1 + ' "  />')
          .attr("role", b1)
          .addClass(parseInt(data.style.color) === b1 ? "selected" : "")
      );
    });

    let icon = $('<ul class="menu-pane-icon"/>');
    BsyUtils.forEach(icons, function (a1, b1) {
      icon.append(
        $('<div class="menu-item color-cover-' + parseInt(data.style.color) + ' "  />')
          .attr("role", b1)
          .addClass(setIconChoose(a1, b1))
          .append("<div class=' imgbg-bby-app imgbg-bby-app-" + b1 + "' >")
      );
    });
    let style_list = $('<div class="bby-workspace-app-style-pane t-bby-workspace-app-style-pane"/>');
    style_list.append(color);
    // style_list.append("<div class='menu-pane-split'>");
    style_list.append(icon);
    FX.Msg.bubble({
      anchor: renderEl,
      contentHTML: style_list,
      text4Cancel: null,
      workerMaxHeight: '580px',
      text4Ok: null,
      width: 360,
      dockPosition: "left",
      contentPadding: 0,
      edge: 350,
      onClose: function () {
        FX.Utils.ajax(
          {
            url: "/dashboard/app/" + data._id + "/update",
            data: curre_val,
          },
          function (d) {
            if (d.code == 3007) {
              tipAlert({
                type: "warning",
                msg: React.language(d.msg) || React.language("error.201"),
              });
            }
            const newApps = _this.state.apps.map((item) => {
              item.apps.map((res1) => {
                if (res1._id === data._id) {
                  res1.style = curre_val;
                }
                return res1;
              });
              return item;
            });
            _this.setState({
              apps: newApps,
              items: _this.getAppGroupList(newApps || []),
            });
            // pubsub.publish("updateApps");
          },
          function (a, b) {
            let c = a.responseJSON || {};
            tipAlert({
              type: "error",
              msg: React.language(c.msg) || React.language("error.201"),
            });
          },
          function () { }
        );
        renderEl.parent().removeClass("select");
        return !1;
      },
    });
    color.bind("click", function (f) {
      let g = $(f.target).closest(".menu-item");
      let h = g.attr("role");
      if (h !== undefined) {
        color.children(".menu-item").removeClass("selected");
        g.addClass("selected");
        icon
          .children(".menu-item")
          .removeClass("color-cover-" + curre_val.color);
        renderEl
          .parent()
          .find(".icon-backgroup")
          .removeClass("color-cover-" + curre_val.color);
        curre_val.color = h;
        icon.children(".menu-item").addClass("color-cover-" + curre_val.color);
        renderEl
          .parent()
          .find(".icon-backgroup")
          .addClass("color-cover-" + curre_val.color);
      }
    });
    icon.bind("click", function (f) {
      let g = $(f.target).closest(".menu-item");
      let h = g.attr("role");
      if (h !== undefined) {
        icon.children(".menu-item").removeClass("selected");
        g.addClass("selected");
        renderEl
          .parent()
          .find(".icon-backgroup div")
          .removeClass("imgbg-bsy-app-" + curre_val.icon);
        curre_val.icon = h;
        renderEl
          .parent()
          .find(".icon-backgroup div")
          .addClass("imgbg-bsy-app-" + curre_val.icon);
      }
    });
  };

  copyApp = (b, groupid, cb) => {
    if (!b) {
      tipAlert({
        type: "warning",
        msg: React.language("select.app.group"),
      });
      return;
    }
    let c = this;
    const { apps } = c.state;
    let layerRef = null;
    BsyMaskLayer({
      customCls: "sloading",
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <div>
            <BsySLoading />{" "}
          </div>
        );
      },
    });

    React.axios("/dashboard/app/" + b._id + "/copy", {
      groupid: groupid,
    })
      .then((res) => {
        const { data: a } = res;
        layerRef && layerRef.close();
        let b = a.app;
        let appData = { parent: groupid };
        appData.appname = b.name;
        appData.copyable = b.copyable;
        appData.deletable = b.deletable;
        appData.editable = b.editable;
        appData.disable_export = b.disable_export;
        appData.editable = b.editable;
        appData.style = b.style;
        appData._id = b._id;

        BsyUtils.forEach(apps, (key, res) => {
          if (res._id === groupid) {
            res.apps.push(appData);
          }
        });
        c.setState(
          {
            apps: apps,
          },
          () => {
            tipAlert({
              type: "success",
              msg: React.language("app.copy.success"),
            });
            pubsub.publish("updateApps");
            cb && cb();
          }
        );
      })
      .catch((res) => {
        console.error(res);
        layerRef && layerRef.close();
      });

    // FX.Utils.ajax({
    //     url: "/dashboard/app/" + b._id + "/copy",
    //     data: {
    //         groupid: groupid
    //     }
    // }, function (a) {
    //     layerRef && layerRef.close();
    //     let b = a.app;
    //     let appData = { parent: groupid };
    //     appData.appname = b.name;
    //     appData.copyable = b.copyable;
    //     appData.deletable = b.deletable;
    //     appData.editable = b.editable;
    //     appData.disable_export = b.disable_export;
    //     appData.editable = b.editable;
    //     appData.style = b.style;
    //     appData._id = b._id;

    //     BsyUtils.forEach(apps, (key, res) => {
    //         if (res._id === groupid) {
    //             res.apps.push(appData)
    //         }
    //     })
    //     c.setState({
    //         apps: apps
    //     }, () => {
    //         // pubsub.publish('updateApps')
    //         // pubsub.publish('updateAppMenu', { apps })
    //         tipAlert({
    //             type: "success",
    //             msg: React.language("app.copy.success")
    //         });
    //         cb && cb();
    //     })

    // }, function (f, g) {
    //     let h = f.responseJSON || {}
    //         , e = h.msg || "";

    //     FX.Msg.alert({
    //         type: "error",
    //         title: React.language("copy.app"),
    //         msg: React.language("app.copy.fail") + e,
    //         onOk: function () {
    //             cb && cb();
    //         },
    //         onCancel: function () {
    //             cb && cb();
    //         },
    //     })
    // }, function () {
    //     load && load.remove()
    // })
  };

  _fetchAppList = (e) => {
    let t = this;
    let hasUpdate = false;
    this.appList
      ? e && e(this.appList)
      : React.axios("/dashboard/app_group/list").then(async (res) => {
        let i = res.data;
        i.items.map((res) => {
          res.apps.map((res1) => {
            if (res1.appType === 4) {
              hasUpdate = true;
            }
            return null;
          });
          return null;
        });
        let standardUpdateCont = {};
        if (
          hasUpdate &&
          (window.FX.STATIC.user_corps.isSysManager ||
            window.FX.STATIC.user_corps.isCorpOwn)
        ) {
          let res = await React.axios("/dashboard/standard_check_renew");
          standardUpdateCont = res.data;
        }
        t.setState(
          {
            apps: i.items,
            dockItem: i.dock_items || [],
            standardUpdateCont: standardUpdateCont,
            hasUpdate: standardUpdateCont.hasRenew,
          },
          () => {
            t.props?.onStandardAppUpdate(standardUpdateCont.hasRenew);
          }
        );
        e && e(i.items, standardUpdateCont);
      });
  };

  _getAppGroups = (t, renderEl) => {
    let i = this;
    const { apps } = this.state;
    this._fetchAppList(function (e) {
      let select = null;
      let dialogRef = null;
      BsyDialog({
        title: React.language("template.install.toGroup"),
        width: 450,
        height: 390,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onContentCreate: (ref) => {
          dialogRef = ref;
          return (
            <GroupSelectPane
              list={apps}
              onSelect={(id, save, file) => {
                select = id;
              }}
            />
          );
        },
        onOk: () => {
          if (!select) {
            tipAlert({
              type: "warning",
              msg:
                React.language("dash.data.manage.selectPlaceholder") +
                React.language("group"),
            });
            return false;
          }
          i.copyApp(t, select, function () {
            dialogRef && dialogRef.close();
          });
          // this._installApp({ mode: "blank", groupid: select });
        },
      });
    });
  };

  _createQrcode = (e, renderEl) => {
    let FX = window.FX;
    let $ = window.$;
    let t = $(".url-icon-qrcode"),
      i = $('<div class="qrcode-dropdown"/>');
    $("<div id ='qrcode' style='border:solid 10px #fff;' />").appendTo(i);
    FX.Msg.bubble({
      anchor: t,
      dockPosition: "right",
      text4Ok: null,
      minWidth: 150,
      text4Cancel: null,
      contentHTML: i,
      scrollObj: $("#content"),
      hAdjust: 15,
    });
    const pot = renderEl[0].getBoundingClientRect();
    const css =
      160 >
        document.documentElement.clientHeight -
        pot.top +
        renderEl[0].offsetHeight +
        2
        ? {
          left: pot.left + "px",
          minWidth: renderEl[0].offsetWidth,
          bottom: document.documentElement.clientHeight - pot.top + 2 + "px",
        }
        : {
          left: pot.left + "px",
          minWidth: renderEl[0].offsetWidth,
          top: pot.top + renderEl[0].offsetHeight + 2 + "px",
        };
    BsyAlertQrcode({
      value: encodeURI(e), //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,
      anchor: $("#qrcode")[0],
      text: React.language("msg.qrCode"),
      fgColor: "#000000",
    });
  };

  _showInstallLog = (id) => {
    React.axios("/data/ins/" + id + "/log").then((res) => {
      const { log: data } = res.data;

      BsyDialog({
        title: React.language("installation.record"),
        customCls: "bsy-install-log-table",
        width: 580,
        height: 580,
        noFooter: false,
        okText: React.language("ok"),
        cancelText: React.language("cancel"),
        onContentCreate: (ref) => {
          return (
            <table cellPadding="0" cellSpacing="0">
              <thead>
                <tr>
                  <td>{React.language("install.account")}</td>
                  <td>{React.language("install.nickname")}</td>
                  <td>{React.language("install.time")}</td>
                </tr>
              </thead>
              {data.length === 0 ? (
                <tbody>
                  <tr>
                    <td colSpan="3" style={{ textAlign: "center" }}>
                      {React.language("no.installation.record")}
                    </td>
                  </tr>
                </tbody>
              ) : (
                <>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.account}</td>
                        <td>{item.username}</td>
                        <td>{BsyUtils.date2Str(dayjsUtils.timeToTZ(item.installdate), "yyyy-MM-dd HH:mm:ss")}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ textAlign: "center" }} colSpan="3">
                        {React.language("show.latest.record")}
                      </td>
                    </tr>
                  </tfoot>
                </>
              )}
            </table>
          );
        },
        onOk: () => {
          return false;
        },
      });
    });
  };

  _shareAppInstall = (d, renderEl) => {
    let FX = window.FX;
    let $ = window.$;
    let e = this,
      t = d.shareInstall || [],
      i = {
        isInstall: t.isInstall || !1,
        installPwd: t.installPwd || null,
        installAccount: t.installAccount || null,
      },
      n =
        FX.CONFIG.HOST.SITE_HOST +
        (window.root_directroy ? window.root_directroy + "/" : "") +
        "data/ins/" +
        d._id,
      a = $('<div class="share-app-install"/>'),
      s = $('<div class="pane-head"/>')
        .append($("<span/>").text(React.language("installation.link")))
        .append(
          $('<span class="subtitle"/>').text(
            React.language("installation.app.link")
          )
        )
        .appendTo(a),
      u = new FX.Switch({
        renderEl: $('<div class="head-line"/>').appendTo(s),
        value: i.isInstall,
        onSwitch: function (e) {
          e ? o.slideDown("fast") : o.slideUp("fast");
          let y = u.getValue(),
            t = h.getWidgetByName("passSwitch").getValue(),
            i = h.getWidgetByName("accountSwitch").getValue(),
            n = h.getWidgetByName("installPwd"),
            a = h.getWidgetByName("installAccount"),
            s = null,
            z = null,
            r = !0;
          if (t) {
            if (n.getValue() === "") {
              s = null;
            } else {
              s = n.getValue();
            }
            n.checkValidate();
          }
          if (
            (t &&
              ((s = n.getValue() === "" ? null : n.getValue()),
                n.checkValidate()),
              r)
          )
            if ((i && ((z = a.getValue()), !BsyUtils.isEmpty(o))) || !i) {
              let l = null;
              BsyUtils.isEmpty(z) || (l = z.split(/[\n]+/));
              let c = {
                isInstall: y,
                installPwd: s,
                installAccount: l,
              };
              d.shareInstall = c;
              FX.Utils.dataAjax(
                {
                  url: "/data/ins/" + d._id + "/update",
                  data: c,
                },
                function () {
                  tipAlert({
                    type: "success",
                    msg: React.language("saveInfo.success"),
                  });
                },
                function (e) {
                  let t = e.responseJSON;
                  t &&
                    tipAlert({
                      type: "error",
                      msg: t.msg || React.language("saveInfo.fail"),
                    });
                }
              );
            } else a.showErrorMsg(React.language("account.no.empty"));
        },
      }),
      o = $('<div class="pane-body t-pane-body"/>').appendTo(a),
      h = new FX.TableContainer({
        renderEl: $("<div/>").appendTo(o),
        rowSize: [1, 30, 30, 1, 30, 30, 1, 30, 80],
        colSize: [148, 40, 40, 40],
        hgap: 5,
        vgap: 10,
        padding: 10,
        items: [
          [
            {
              type: "separator",
              width: "100%",
            },
          ],
          [
            {
              type: "label",
              text: React.language("app.installation.link"),
              baseCls: "x-label pane-label",
            },
          ],
          [
            {
              type: "text",
              widgetName: "installUrl",
              enable: !1,
              width: 400,
              height: 30,
              text: n,
            },
            $(
              '<a class="share-open x-btn style-white" title=React.language("openLink") target="_blank"/>'
            )
              .attr("href", n)
              .text(React.language("open")),
            $(
              '<a class="share-open x-btn style-white" title=React.language("link.copy")/>'
            )
              .text(React.language("copy"))
              .on("click", function () {
                FX.Utils.copyToClipboard(n, function () {
                  tipAlert({
                    type: "success",
                    msg: React.language(
                      "installation.copied.link.successfully"
                    ),
                  });
                });
              }),
            $("<i class='icon-qrcode url-icon-qrcode'/>")
              .attr(
                "title",
                React.language("generate.copied.link.successfully")
              )
              .on("click", function () {
                e._createQrcode(n, $(this));
              }),
          ],
          [
            {
              type: "separator",
              width: "100%",
            },
          ],
          [
            {
              type: "label",
              text: React.language("install.password"),
              baseCls: "x-label pane-label",
            },
          ],
          [
            {
              type: "switch",
              width: 44,
              height: 22,
              widgetName: "passSwitch",
              value: !!i.installPwd,
              onSwitch: function (e) {
                let t = h.getWidgetByName("installPwd");
                if (e) {
                  t.setVisible(!0);
                  t.select();
                } else {
                  t.setVisible(!1);
                }
                let i = h.getWidgetByName("accountSwitch"),
                  n = h.getWidgetByName("installAccount");
                if (e) {
                  i.setValue(!1);
                  n.setVisible(!1);
                }
                let y = u.getValue(),
                  k = h.getWidgetByName("passSwitch").getValue(),
                  p = h.getWidgetByName("accountSwitch").getValue(),
                  q = h.getWidgetByName("installPwd"),
                  a = h.getWidgetByName("installAccount"),
                  s = null,
                  z = null,
                  r = !0;
                if (
                  (k && ((s = q.getValue()), q.checkValidate() || (r = !1)), r)
                )
                  if ((p && ((z = a.getValue()), !BsyUtils.isEmpty(o))) || !p) {
                    let l = null;
                    BsyUtils.isEmpty(z) || (l = z.split(/[\n]+/));
                    let c = {
                      isInstall: y,
                      installPwd: s,
                      installAccount: l,
                    };
                    d.shareInstall = c;
                    FX.Utils.dataAjax(
                      {
                        url: "/data/ins/" + d._id + "/update",
                        data: c,
                      },
                      function () {
                        tipAlert({
                          type: "success",
                          msg: React.language("saveInfo.success"),
                        });
                      },
                      function (e) {
                        let t = e.responseJSON;
                        t &&
                          tipAlert({
                            type: "error",
                            msg: t.msg || React.language("saveInfo.fail"),
                          });
                      }
                    );
                  } else a.showErrorMsg(React.language("account.no.empty"));
              },
            },
            {
              type: "text",
              widgetName: "installPwd",
              visible: !!i.installPwd,
              allowBlank: !1,
              waterMark: React.language("query.pass.type"),
              text: i.installPwd,
              width: 200,
              height: 30,
              regex: "^.{1,24}$",
              onStopEdit: function () {
                let y = u.getValue(),
                  k = h.getWidgetByName("passSwitch").getValue(),
                  p = h.getWidgetByName("accountSwitch").getValue(),
                  q = h.getWidgetByName("installPwd"),
                  a = h.getWidgetByName("installAccount"),
                  s = null,
                  z = null,
                  r = !0;
                if (
                  (k &&
                    ((s = q.getValue()),
                      q.checkValidate() ||
                      (q.showErrorMsg(React.language("limit.password")),
                        (r = !1))),
                    r)
                )
                  if ((p && ((z = a.getValue()), !BsyUtils.isEmpty(o))) || !p) {
                    let l = null;
                    BsyUtils.isEmpty(z) || (l = z.split(/[\n]+/));
                    let c = {
                      isInstall: y,
                      installPwd: s,
                      installAccount: l,
                    };
                    d.shareInstall = c;
                    FX.Utils.dataAjax(
                      {
                        url: "/data/ins/" + d._id + "/update",
                        data: c,
                      },
                      function () {
                        tipAlert({
                          type: "success",
                          msg: React.language("saveInfo.success"),
                        });
                      },
                      function (e) {
                        let t = e.responseJSON;
                        t &&
                          tipAlert({
                            type: "error",
                            msg: t.msg || React.language("saveInfo.fail"),
                          });
                      }
                    );
                  } else a.showErrorMsg(React.language("account.no.empty"));
              },
            },
          ],
          [
            {
              type: "separator",
              width: "100%",
            },
          ],
          [
            {
              type: "label",
              width: 170,
              text: React.language("accounts.allowed.install"),
              baseCls: "x-label pane-label",
            },
          ],
          [
            {
              type: "switch",
              width: 44,
              height: 22,
              widgetName: "accountSwitch",
              value: !!i.installAccount,
              onSwitch: function (e) {
                let t = h.getWidgetByName("installAccount");
                if (e) {
                  t.setVisible(!0);
                  t.select();
                } else {
                  t.setVisible(!1);
                }
                let i = h.getWidgetByName("passSwitch"),
                  n = h.getWidgetByName("installPwd");
                if (e) {
                  i.setValue(!1);
                  n.setVisible(!1);
                }
                let y = u.getValue(),
                  k = h.getWidgetByName("passSwitch").getValue(),
                  p = h.getWidgetByName("accountSwitch").getValue(),
                  q = h.getWidgetByName("installPwd"),
                  a = h.getWidgetByName("installAccount"),
                  s = null,
                  z = null,
                  r = !0;
                if (
                  (k &&
                    ((s = q.getValue()),
                      q.checkValidate() ||
                      (q.showErrorMsg(React.language("limit.password")),
                        (r = !1))),
                    r)
                )
                  if ((p && ((z = a.getValue()), !BsyUtils.isEmpty(o))) || !p) {
                    let l = null;
                    BsyUtils.isEmpty(z) || (l = z.split(/[\n]+/));
                    let c = {
                      isInstall: y,
                      installPwd: s,
                      installAccount: l,
                    };
                    d.shareInstall = c;
                    FX.Utils.dataAjax(
                      {
                        url: "/data/ins/" + d._id + "/update",
                        data: c,
                      },
                      function () {
                        tipAlert({
                          type: "success",
                          msg: React.language("saveInfo.success"),
                        });
                      },
                      function (e) {
                        let t = e.responseJSON;
                        t &&
                          tipAlert({
                            type: "error",
                            msg: t.msg || React.language("saveInfo.fail"),
                          });
                      }
                    );
                  } else a.showErrorMsg(React.language("account.no.empty"));
              },
            },
            {
              type: "textarea",
              visible: !!i.installAccount,
              widgetName: "installAccount",
              waterMark: React.language("enter.app.accounts"),
              width: 350,
              value: i.installAccount ? i.installAccount.join("\n") : "",
              onStopEdit: function () {
                let y = u.getValue(),
                  k = h.getWidgetByName("passSwitch").getValue(),
                  p = h.getWidgetByName("accountSwitch").getValue(),
                  q = h.getWidgetByName("installPwd"),
                  a = h.getWidgetByName("installAccount"),
                  s = null,
                  z = null,
                  r = !0;
                if (
                  (k &&
                    ((s = q.getValue()),
                      q.checkValidate() ||
                      (q.showErrorMsg(React.language("limit.password")),
                        (r = !1))),
                    r)
                )
                  if ((p && ((z = a.getValue()), !BsyUtils.isEmpty(o))) || !p) {
                    let l = null;
                    BsyUtils.isEmpty(z) || (l = z.split(/[\n]+/));
                    let c = {
                      isInstall: y,
                      installPwd: s,
                      installAccount: l,
                    };
                    d.shareInstall = c;
                    FX.Utils.dataAjax(
                      {
                        url: "/data/ins/" + d._id + "/update",
                        data: c,
                      },
                      function () {
                        tipAlert({
                          type: "success",
                          msg: React.language("saveInfo.success"),
                        });
                      },
                      function (e) {
                        let t = e.responseJSON;
                        t &&
                          tipAlert({
                            type: "error",
                            msg: t.msg || React.language("saveInfo.fail"),
                          });
                      }
                    );
                  } else a.showErrorMsg(React.language("account.no.empty"));
              },
            },
          ],
        ],
      }),
      r =
        ($('<span class="install-log"/>')
          .text(React.language("view.installed.records"))
          .on("click", function () {
            e._showInstallLog(d._id);
          })
          .appendTo($('<div class="pane-foot">').appendTo(a)),
          new FX.ConfirmDialog({
            customCls: "margintop",
            title: React.language("Share.app.install.others", {
              appname: d.appname,
            }),
            width: 580,
            height: 580,
            onContentCreate: null,
            text4Ok: null,
            text4Cancel: null,
            contentWidget: {
              rowSize: [380],
              colSize: [560],
              padding: 10,
              items: [a],
            },
          }));
    i.isInstall ? o.show() : o.hide();
    r.show();
    renderEl.parent().removeClass("select");
  };

  removeApp = (appData, renderEl) => {
    const { apps } = this.state;
    BsyAlert({
      type: "error-input",
      title: React.language("want.delete.app", { appname: appData.appname }),
      msg: React.language("delete.form.irreversible"),
      text4Ok: React.language("delete"),
      OkType: "red",
      placeholder: React.language("delete.app.name"),
      text4Cancel: React.language("cancel"),
      onInputValidate: (val) => {
        return appData.appname === val;
      },
      ok: (val, el) => {
        let layerRef = null;
        BsyMaskLayer({
          customCls: "hasBackground",
          onContentCreate: (ref) => {
            layerRef = ref;
            return (
              <div>
                <BsySLoading />
              </div>
            );
          },
        });

        React.axios("/dashboard/app/" + appData._id + "/remove", {})
          .then(() => {
            BsyUtils.forEach(apps, (obj, res) => {
              layerRef && layerRef.close();

              if (appData.parent === res._id) {
                BsyUtils.forEach(res.apps, (obj1, res1) => {
                  if (appData._id === res1._id) {
                    apps[obj].apps.splice(obj1, 1);
                    this.setState(
                      {
                        apps: [...apps],
                      },
                      () => {
                        tipAlert({
                          type: "success",
                          msg: React.language("app.delete.success"),
                        });

                        pubsub.publish("updateApps");
                      }
                    );
                  }
                });
              }
            });
          })
          .catch((res) => {
            console.error(res);
            layerRef && layerRef.close();
          });
      },
    });
    // return;

    // let FX = window.FX;
    // let $ = window.$;
    // const _this = this;
    // const { apps } = this.state;
    // function e(e) {
    //   s &&
    //     s.okBtn &&
    //     (e === appData.appname
    //       ? s.okBtn.setOnClick(!0)
    //       : s.okBtn.setOnClick(!1));
    // }

    // let n = $(
    //     '<div class="app-remove-confirm" style="marginTop: 20px;padding-left: 44px"/>'
    //   ),
    //   a = $('<div class="app-input-name"/>').appendTo(n);

    // new FX.TextEditor({
    //   renderEl: $('<div class="input-widget"/>').appendTo(a),
    //   waterMark: React.language("delete.app.name"),
    //   width: "100%",
    //   onAfterEdit: function () {
    //     e(this.getValue());
    //   },
    //   onStopEdit: function () {
    //     e(this.getValue());
    //   },
    // });
    // let s = FX.Msg.alert({
    //   title: React.language("want.delete.app", { appname: appData.appname }),
    //   msg: React.language("delete.form.irreversible"),
    //   content: n,
    //   type: "swarning",
    //   enable4Ok: !1,
    //   onOk: function () {
    //     let layerRef = null;
    //     BsyMaskLayer({
    //       customCls: "hasBackground",
    //       onContentCreate: (ref) => {
    //         layerRef = ref;
    //         return (
    //           <div>
    //             <BsySLoading />
    //           </div>
    //         );
    //       },
    //     });

    //     React.axios("/dashboard/app/" + appData._id + "/remove", {})
    //       .then(() => {
    //         BsyUtils.forEach(apps, (obj, res) => {
    //           // window.location.reload()
    //           // return ;

    //           renderEl.parent().removeClass("select");
    //           if (appData.parent === res._id) {
    //             BsyUtils.forEach(res.apps, (obj1, res1) => {
    //               if (appData._id === res1._id) {
    //                 apps[obj].apps.splice(obj1, 1);
    //                 _this.setState(
    //                   {
    //                     apps: apps,
    //                   },
    //                   () => {
    //                     tipAlert({
    //                       type: "success",
    //                       msg: React.language("app.delete.success"),
    //                     });

    //                     // pubsub.publish("updateApps");
    //                   }
    //                 );
    //               }
    //             });
    //           }
    //         });
    //         layerRef && layerRef.remove();
    //       })
    //       .catch((res) => {
    //         console.error(res);
    //         layerRef && layerRef.remove();
    //         renderEl.parent().removeClass("select");
    //       });
    //   },
    //   onCancel: function () {
    //     renderEl.parent().removeClass("select");
    //   },
    // });
    // e();
  };

  openUpdateStandardAppPane = (appId) => {
    BsySlidePane({
      title: React.language("update.app"),
      hasHeader: true,
      onContentCreate: (ref) => {
        return (
          <UpdateStandardAppPane
            slideRef={ref}
            appId={appId}
            apps={this.state.apps}
            loadAppList={this._fetchAppList}
            standardUpdateData={this.state.standardUpdateCont}
          />
        );
      },
      onClose: () => {
        if (window.hasUpdateApp) {
          window.location.reload();
        }
        return true;
      },
    });
  };

  eventCustMent = (h, appData, renderEl) => {
    renderEl.parent().addClass("select");
    let d = this;
    if (h) {
      switch (h) {
        case "rename": {
          d._appReName(
            appData._id,
            renderEl,
            appData.appname,
            function (appname) {
              appData.appname = appname;
              renderEl.data(appData);
            }
          );
          break;
        }

        case "editstyle": {
          d._appEditStyle(renderEl, appData);
          break;
        }
        case "move": {
          d._appMove(appData, renderEl);
          break;
        }

        case "copy": {
          d._getAppGroups(appData, renderEl);
          break;
        }

        case "share": {
          d._shareAppInstall(appData, renderEl);
          break;
        }

        case "delete": {
          d.removeApp(appData, renderEl);
          break;
        }
        case "downapp":
          d.downapp(appData, renderEl);
          break;
        case "updateapp":
          d.updateapp(appData, renderEl);
          break;
        case "unbind":
          d.unbind(appData, renderEl);
          break;
        case "debug": {
          d.debug(appData, renderEl);
          break;
        }
        default: {
        }
      }
    }
  };

  _appMove = (appData, renderEl) => {
    let select = null;
    BsyDialog({
      title: React.language("template.install.toGroup"),
      width: 450,
      height: 390,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        return (
          <GroupSelectPane
            list={this.state.apps}
            onSelect={(id, save, file) => {
              select = id;
            }}
          />
        );
      },
      onOk: () => {
        if (!select) {
          tipAlert({
            type: "warning",
            msg:
              React.language("dash.data.manage.selectPlaceholder") +
              React.language("group"),
          });
          return false;
        }

        React.axios("/dashboard/app_group/appmove", {
          source: appData.parent,
          appId: appData._id,
          to: select,
        }).then((res) => {
          const { data: d } = res;

          if (d.code === 0) {
          } else {
            tipAlert({
              type: "warning",
              msg:
                React.language(d.msg) || React.language("app.edit.group.fail1"),
            });
          }
          this._fetchAppList();
        });
      },
    });

    // let i = this
    //     , n = window.$('<div class="app-ref-copy-content">');
    // this._fetchAppList(function (e) {
    //     let a = new FX.AppInstallGroup({
    //         renderEl: n,
    //         groups: e,
    //     });
    //     i.moveDialog = new FX.ConfirmDialog({
    //         title: React.language("move.app.toGroup"),
    //         width: 450,
    //         height: 390,
    //         onContentCreate: function (e) {
    //             e.append(n)
    //         },
    //         onOk: function () {
    //             let toappid = a.getValue();
    //             let h = toappid.groupId
    //             FX.Utils.ajax({
    //                 url: i.state.isStandard ? "/dashboard/standardapp_group/appmove" : "/dashboard/app_group/appmove",
    //                 data: {
    //                     source: appData.parent,
    //                     appId: appData._id,
    //                     to: h
    //                 }
    //             }, function (d) {
    //                 if (d.code === 0) {

    //                 } else {
    //                     tipAlert({
    //                         type: "warning",
    //                         msg: React.language(d.msg) || React.language("app.edit.group.fail1")
    //                     })
    //                 }
    //                 i._fetchAppList();
    //                 i.moveDialog.close();
    //             }, function (a, b) {
    //                 let c = a.responseJSON || {};
    //                 tipAlert({
    //                     type: "error",
    //                     msg: React.language(c.msg) || React.language("app.edit.group.fail3")
    //                 })
    //                 i._fetchAppList();
    //                 i.moveDialog.close();
    //             }, function () {
    //                 renderEl.closest(".bby-msg-bubble").remove()
    //                 i.comboGroupList = null;
    //                 i._fetchAppList();
    //                 i.moveDialog.close();
    //             })
    //             renderEl.parent().removeClass("select");
    //         },
    //         onCancel: function () {
    //             renderEl.parent().removeClass("select");
    //             i.moveDialog.close()
    //         }
    //     })
    //     renderEl.parent().removeClass("select");
    //     i.moveDialog.show()
    // })
  };

  moreMenu = (data, event) => {
    // console.log(data, index, event)
    let $ = window.$;
    let menu = [];
    if (
      window.FX.STATIC.user_corps.isSysManager ||
      window.FX.STATIC.user_corps.isCorpOwn
    ) {
      if (data.editable) {
        menu.push({
          text: React.language("app.style.edit"),
          colorType: "",
          icon: "icon-bsy-iconyangshi",
          click: () => {
            this.eventCustMent("editstyle", data, $(event.target));
          },
        });
        menu.push({
          text: React.language("name.update"),
          colorType: "",
          icon: "icon-bsy-iconxiugai",
          click: () => {
            this.eventCustMent("rename", data, $(event.target));
          },
        });
      }
      if ((data.appType !== 4 && data.appType !== 3) && data.copyable) {
        menu.push({
          text: React.language("app.copy"),
          colorType: "",
          icon: "icon-bsy-iconfuzhi",
          click: () => {
            this.eventCustMent("copy", data, $(event.target));
          },
        });
      }
      if (data.editable) {
        menu.push({
          text: React.language("clean.data"),
          colorType: "",
          icon: "icon-bsy-iconqingli",
          click: () => {
            BsyAlert({
              title: React.language("clear.data.app", {
                appname: data.appname,
              }),
              msg: React.language("clear.data.irreversible"),
              type: "error-input",
              onInputValidate: (val) => {
                return val === data.appname;
              },
              text4Ok: React.language("delete"),
              OkType: "red",
              placeholder: React.language("clear.app.name"),
              text4Cancel: React.language("cancel"),
              ok: (value) => {
                if (data.appname !== value) {
                  tipAlert({
                    type: "warning",
                    msg: React.language("empty.report.tip8"),
                  });
                  return !1;
                }

                React.axios("/dashboard/app/" + data._id + "/clean", {
                  groupId: data._id,
                })
                  .then((res) => {
                    tipAlert({
                      type: "success",
                      msg: React.language("app.data.cleared"),
                    });
                  })
                  .catch((res) => {
                    console.error(res);
                  });
                return true;
              },
            });
          },
        });
      }

      menu.push({
        text: React.language("moveTo.other.group"),
        colorType: "",
        icon: "icon-bsy-help-13",
        line: data.deletable || data.editable,
        click: () => {
          this.eventCustMent("move", data, $(event.target));
        },
      });

      if (data.deletable) {
        menu.push({
          text: React.language("app.delete"),
          icon: "icon-bsy-iconshanchu",
          colorType: "red",
          click: () => {
            this.eventCustMent("delete", data, $(event.target));
          },
        });
      }
      if (data.editable) {
        if (!data.disable_export) {
          menu.push({
            text: React.language("share.others.install"),
            colorType: "",
            icon: "icon-bsy-iconfenxianggei",
            click: () => {
              this.eventCustMent("share", data, $(event.target));
            },
          });
        }
        if (
          data.appType === 4 &&
          (BsyUtils.isSysManager() || BsyUtils.isCorpOwn())
        ) {
          menu.push({
            line: true,
          });
          menu.push({
            text: React.language("unbind"),
            colorType: "",
            icon: "icon-bsy-standard-unbind",
            click: () => {
              this.eventCustMent("unbind", data, $(event.target));
            },
          });
          menu.push({
            text: React.language("project.debug"),
            colorType: "",
            icon: "icon-bsy-standard-debug",
            click: () => {
              this.eventCustMent("debug", data, $(event.target));
            },
          });
        }
      }
    } else if (window.FX.STATIC.user_corps.isSubAdmin) {
      if (data.editable) {
        menu.push({
          text: React.language("app.style.edit"),
          colorType: "",
          icon: "icon-bsy-iconyangshi",
          click: () => {
            this.eventCustMent("editstyle", data, $(event.target));
          },
        });
        menu.push({
          text: React.language("name.update"),
          colorType: "",
          icon: "icon-bsy-iconxiugai",
          click: () => {
            this.eventCustMent("rename", data, $(event.target));
          },
        });
      }
    }
    const currentTarget = event.currentTarget;
    currentTarget.parentNode.classList.add("select");
    BsyAlertMenu({
      item: menu,
      width: 220,
      height: "auto",
      target: currentTarget,
      onClose: () => {
        currentTarget.parentNode.classList.remove("select");
      },
    });

    event.stopPropagation();
  };

  getAppGroupList = (apps) => {
    let list = [
      {
        title: React.language("allapp"),
        key: "all",
        content: "",
      },
      {
        title: React.language("workbench.myApp.title"),
        key: "manager",
        content: "",
      },
    ];
    let allapp = [];
    let managerapp = []; //我管理的
    apps
      .filter((item) => !BsyUtils.isObjectEmpty(item.apps))
      .map((item, groupIndex) => {
        const id = `tab_${item._id}_${groupIndex}`;
        list.push({
          title: item.name,
          key: id,
          appCount: (item.apps || []).length,
          content: (
            <div className="bys-group-box" key={id}>
              {(item.apps || []).map((data, index) => {
                const hasAuth =
                  window.FX.STATIC.user_corps.isSysManager ||
                  data.editable ||
                  data.deletable ||
                  data.copyable;
                if (hasAuth && !data.dock) {
                  managerapp.push(data);
                }
                return this.groupItem(data, id);
              })}
            </div>
          ),
        });
        allapp = allapp.concat(item.apps);
        return null;
      });

    if (this.props.mode !== "edit") {
      // 18个应用内，不做分组
      if (allapp <= 18) {
        list[0].content = (
          <div className="bys-group-box">
            {(allapp || []).map((data, index) => {
              return this.groupItem(data, "allapp");
            })}
          </div>
        );
      } else {
        const app = apps || [];

        list[0].content = (
          <div className="bys-group-box-all" key={"all"}>
            {app
              .filter((item) => !BsyUtils.isObjectEmpty(item.apps))
              .map((data, index) => {
                const id = `all-${data._id}-${index}`;
                return (
                  <div key={id}>
                    <div className="group-title">{data.name}</div>
                    <div className="bys-group-box">
                      {(data.apps || []).map((data1, index1) => {
                        return this.groupItem(data1, id);
                      })}
                    </div>
                  </div>
                );
              })}
          </div>
        );
      }
      list[0].appCount = allapp.length;
      if (managerapp.length > 0) {
        //  我管理的应用
        list[1].content = (
          <div className="bys-group-box">
            {(managerapp || []).map((data, index) => {
              return this.groupItem(data, "managerapp");
            })}
          </div>
        );
      } else {
        list.splice(1, 1);
      }
    } else {
      list.splice(0, 2);
    }
    // debugger
    return [...list];
  };

  selectApp = (appinfo) => {
    // this.props.history.push(`${window.rootDirectroy}/team/app/${appinfo._id}`)
    return () => {
      window.location.href = `${window.rootDirectroy}/team/app/${appinfo._id}`;
    };
  };

  updateapp = (appData, renderEl) => {
    BsyDialog({
      title: React.language("unbind"),
      height: 340,
      width: 440,
      noFooter: false,
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onOk: () => {
        renderEl.parent().removeClass("select");
      },
      onCancel: () => {
        renderEl.parent().removeClass("select");
      },
      onContentCreate: () => {
        this.packageContent = null;
        return (
          <div className="packageUpdate">
            <div className="update-title">
              <span>{React.language("installation.package.update.title")}</span>
            </div>
            <div className="update-btn">
              <label className="contImg x-btn" htmlFor="file">
                <i className="icon-bsy-file"></i>
                <span>{React.language("Upload.installation.package")}</span>
              </label>
              <input
                type="file"
                id="file"
                name="file"
                className="upload-btn-input"
                accept=".bby,.bsy"
                style={{ display: "none" }}
                onChange={(e) => {
                  this.updatePackage(e, appData._id);
                }}
              />
            </div>
            <div className="updateFile"></div>
          </div>
        );
      },
    });
  };

  unbind = (appData, renderEl) => {
    BsyDialog({
      title: React.language("unbind"),
      height: 360,
      width: 440,
      noFooter: true,
      onContentCreate: (ref) => {
        const tRef = ref;
        return (
          <UnbindApp
            app={appData}
            onClose={() => {
              tRef.closeAlter();
            }}
          />
        );
      },
    });
  };

  debug = (appData, renderEl) => {
    BsyDialog({
      title: React.language("project.debug"),
      height: 260,
      width: 440,
      noFooter: true,
      onContentCreate: (ref) => {
        const tRef = ref;
        return (
          <EditStandardApp
            app={appData}
            onClose={() => {
              tRef.closeAlter();
            }}
          />
        );
      },
    });
  };

  render() {
    const { items, active, apps } = this.state;
    // const boxWidth = this.props.mode === 'edit' ? (document.querySelector('#bby').clientWidth - 340) : (document.querySelector('#bby').clientWidth - 90);
    // const totalMargin = boxWidth % 190;
    // const numMargin = totalMargin / parseInt(boxWidth / 190) / 2;

    return (
      <div className={"dashboard-my-app"}>
        {!items?.[0]?.appCount &&
          (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) ? (
          <CreateApp
            apps={apps}
            title={React.language("webhook.key.create.first.app")}
          />
        ) : (
          <BsyTab
            tabs={items || []}
            defaultActiveKey={active}
            onChange={(key) => {
              this.setState({
                active: key,
              });
            }}
          />
        )}
      </div>
    );
  }
}

export default BsyDashboardMyApp;
